import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useActiveRack = () => {
  return useSelector(
    (state: RootState) =>
      state.activeRack as { rack: string; cell: string; miner?: string }
  );
};
